/** Pixel height of the fixed enterprise admin top bar (CourseraHeader in admin). */
export const ENTERPRISE_ADMIN_NAVBAR_HEIGHT_PX = 66;

/** Pixel width of the expanded admin sidenav. */
export const ADMIN_SIDENAV_WIDTH_EXPANDED_PX = 256;

/** Pixel width of the collapsed admin sidenav. */
export const ADMIN_SIDENAV_WIDTH_COLLAPSED_PX = 80;

/** Millisecond duration for sidenav collapse/expand transition. */
export const ADMIN_SIDENAV_TRANSITION_MS = 180;
